import { auth } from 'firebase';

module.exports = {
  login: (email, password, cb) => {
    auth().signInWithEmailAndPassword(email, password).then(user => {
      cb(user, null);
    }).catch(err => {
      cb(null, err)
    })
  },
  logout: () => {
    return auth().signOut();
  }
}



/** WEBPACK FOOTER **
 ** ./src/Auth/firebase-auth.js
 **/